import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';

import { required, phoneNumber } from '../../../forms';
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import flags from 'react-phone-number-input/flags';


const validate = (values) => {
  const errors = {}
  // TODO add validation
  if (!isValidPhoneNumber(values.mobile)) {
    errors.mobile = 'Please enter valid mobile number.';
  }else if(!isValidPhoneNumber(values.office)) {
    errors.office = 'Please enter valid office number.';
  }
  return errors;
};

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning },}) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className={warning.className}>{warning.msg}</p>))}
  </InputGroup>
);

export const renderPhoneField = ({ input, label, type, meta: { touched, error, warning },}) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className={warning.className}>{warning.msg}</p>))}
  </InputGroup>
);

export const customPhoneInput = ({ input, label, type, country, meta: { touched, error, warning } }) => (
  <InputGroup>
  {label && <ControlLabel>{label}</ControlLabel>}
  <PhoneInput flags={flags} {...input} type={type} country={country}/>
  { input.value ? (isValidPhoneNumber(input.value) ? undefined : <p className="alert alert-danger">Invalid phone number</p>) : <p className="alert alert-danger">Phone number required</p> }
  </InputGroup>
    //placeholder="Enter phone number"
    //value={ input.value}
    //onChange={ value => input.onChange(value) }/>
);

const ProfileForm = ({ onSubmit, initialValues, onClose }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={validate}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="user.first_name"
            type="text"
            component={renderBootstrapField}
            label="First Name"
            validate={required}
          />
          <Field
            name="user.last_name"
            type="text"
            component={renderBootstrapField}
            label="Last Name"
            validate={required}
          />
          <Field
            name="title"
            type="text"
            component={renderBootstrapField}
            label="Title"
          />
        </FormGroup>
        <FormGroup>
          {/* <Field
            name="mobile"
            type="text"
            component={renderPhoneField}
            label="Mobile"
          /> */}
          <Field
            name="mobile"
            type="text"
            country="US"
            component={customPhoneInput}
            label="Mobile (Please select a Country and provide Mobile Number)"
            placeholder="Enter mobile number"
            />
            <Field
            name="office"
            type="text"
            country="US"
            component={customPhoneInput}
            label="Office (Please select a Country and provide Phone Number)"
            placeholder="Enter phone number"
            />
          
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={pristine || submitting}
              bsStyle="info"
              type="submit"
            >
               Save
            </Button>
            <Button
              onClick={onClose}
              bsStyle="info"
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    )}
  />
  );

export default ProfileForm;



// WEBPACK FOOTER //
// src/routes/profile/components/ProfileForm.js